export default __webpack_public_path__ + "static/media/microsoft_logo.5ef2a098.svg";